import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { dictionariesColumn } from 'types';

class AddNewRowCol extends Component {
  static propTypes = {
    col: dictionariesColumn,
    index: PropTypes.number.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    focus: PropTypes.shape({
      row: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      col: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  };

  componentDidUpdate() {
    const { focus, index } = this.props;
    if (focus.row === -1 && focus.col === index) {
      this.inputComponent.focus();
    }
  }

  handleClick = () => {
    const { index, onFocus } = this.props;
    onFocus({
      row: -1,
      col: index,
    });
  };

  handleUpdateCol = ({ target: { value } }) => {
    this.props.onUpdate(this.props.col, value);
  };

  handleRef = el => {
    this.inputComponent = el;
  };

  render() {
    const {
      col: { name, value, archived },
    } = this.props;

    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */

    return (
      <th>
        <input
          ref={this.handleRef}
          data-test="input-value"
          disabled={archived}
          placeholder={name}
          value={value}
          onChange={this.handleUpdateCol}
          onClick={this.handleClick}
        />
      </th>
    );
  }
}

export default AddNewRowCol;
